import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import Table from "components/Table";

import countries from "libs/countries.json";

const UsersTable = ({ data, loading, sort, setSort }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { search } = useLocation();

  const tableData = {
    keys: [
      { sort_key: "first_name", key: "first_name", value: t("Name and surname") },
      { key: "email", value: t("Email") },
      { key: "phone", value: t("Phone") },
      { sort_key: "websites", key: "website", value: t("Website [SHORT]") },
      { sort_key: "type", key: "account_type", value: t("Account type") },
      { key: "details", sort_key: false, value: t("Details") },
    ],
    items: data?.map(
      ({ _id, first_name, last_name, email, phone, websites, type }) => [
        { key: "first_name", value: `${first_name} ${last_name}` },
        { key: "email", value: email },
        {
          key: "phone",
          value: phone?.number
            ? `${
                countries?.find((item) => item?.code === phone?.code)
                  ?.dialling_code || ""
              } ${phone.number}`
            : "-",
        },
        {
          key: "website",
          type: "website_items",
          value: websites?.map((item) => ({
            label: item?.website,
            href: `/clients/${item?._id}`,
          })),
        },
        { key: "account_type", value: t(type) },
        {
          key: "details",
          type: "clickable_text",
          value: {
            label: t("View"),
            onclick: () =>
              navigate(
                type === "webmaster"
                  ? `/webmasters/${_id}/account-settings`
                  : `/users/${_id}${search}`,
              ),
          },
        },
      ],
    ),
  };

  return <Table data={tableData} loading={loading} sort={sort} setSort={setSort} />;
};

export default UsersTable;